import { render, staticRenderFns } from "./clientProfileRemediation.vue?vue&type=template&id=45c1a20c&scoped=true"
import script from "./clientProfileRemediation.vue?vue&type=script&lang=js"
export * from "./clientProfileRemediation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1a20c",
  null
  
)

export default component.exports